import * as React from "react"
export const SearchIcon = ({size,...props}) => (
  <svg
    width={size ?? 20}
    height={size ?? 20}
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}>
    <g>
      <path
        d='M8.35104 15.5629C9.93787 15.5629 11.4195 15.0516 12.624 14.1994L17.1551 18.6875C17.3654 18.8958 17.6426 19 17.9294 19C18.5507 19 19 18.5266 19 17.9206C19 17.6365 18.9044 17.3714 18.6941 17.1631L14.1917 12.6938C15.1381 11.4629 15.7021 9.93845 15.7021 8.28143C15.7021 4.27617 12.3946 1 8.35104 1C4.29793 1 1 4.27617 1 8.28143C1 12.2867 4.29793 15.5629 8.35104 15.5629ZM8.35104 13.9911C5.18694 13.9911 2.58683 11.4061 2.58683 8.28143C2.58683 5.15676 5.18694 2.5718 8.35104 2.5718C11.5056 2.5718 14.1152 5.15676 14.1152 8.28143C14.1152 11.4061 11.5056 13.9911 8.35104 13.9911Z'
        fill='currentColor'
        stroke='currentColor'
      />
    </g>
  </svg>
)
